export default [
    {
        path: '/app/manjian/list.html',
        component: (resolve) => require(['@/view/app/manjian/index.vue'],resolve),
    },
    {
        path: '/app/manjian/add.html',
        component: (resolve) => require(['@/view/app/manjian/add.vue'],resolve),
    },
]
